import { useMediaQuery } from 'react-responsive';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useBreakpoint(query: string) {
  return useMediaQuery({ query: query.replace('@media', '').trim() });
}
